import { render, staticRenderFns } from "./installs.vue?vue&type=template&id=15b2e90d"
import script from "./installs.vue?vue&type=script&lang=js"
export * from "./installs.vue?vue&type=script&lang=js"
import style0 from "./installs.vue?vue&type=style&index=0&id=15b2e90d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports